import { StoresText } from 'types/store/StoreTypes';
import { createSlice } from '@reduxjs/toolkit';
import { ExportRange } from 'types/common/Range';

interface ExportDataState {
  StoresText: StoresText[];
  StoresTextMap: Record<string, string>;
  ProductExportFilters: ExportRange;
  CustomersExportFilters: ExportRange;
}

export const initialState: ExportDataState = {
  StoresText: [],
  StoresTextMap: {},
  ProductExportFilters: {
    start: '',
    end: '',
  },
  CustomersExportFilters: {
    start: '',
    end: '',
  },
};

const ExportDataSlice = createSlice({
  name: 'ExportData',
  initialState,
  reducers: {
    setStoresText: (state, action) => {
      state.StoresText = action.payload;
    },
    setStoresTextMap: (state, action) => {
      state.StoresTextMap = action.payload;
    },
    setProductExportFilters: (state, action) => {
      state.ProductExportFilters = action.payload;
    },
    setCustomersExportFilters: (state, action) => {
      state.ProductExportFilters = action.payload;
    },
  },
});

export const {
  setStoresText,
  setStoresTextMap,
  setProductExportFilters,
  setCustomersExportFilters,
} = ExportDataSlice.actions;

export default ExportDataSlice.reducer;
